import { render, staticRenderFns } from "./contact_form.vue?vue&type=template&id=768d5a04&scoped=true&"
import script from "./contact_form.vue?vue&type=script&lang=ts&"
export * from "./contact_form.vue?vue&type=script&lang=ts&"
import style0 from "./contact_form.vue?vue&type=style&index=0&id=768d5a04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768d5a04",
  null
  
)

export default component.exports